export const personaHeaderViewProfilebutton = "Cab";
export const personaHeaderViewChatButtonLabel = "Dab";
export default {personaHeaderViewProfilebutton,personaHeaderViewChatButtonLabel};